import { withCompInfo } from '@wix/editor-elements-integrations'
import { RefComponentCss, RefComponentDefinition } from './RefComponent'
import _ from 'lodash'

export const css = withCompInfo<RefComponentCss, RefComponentDefinition>()(
	['hasResponsiveLayout', 'compProps'],
	({ hasResponsiveLayout, compProps }, additionalData) => {
		const childHasResponsiveLayout = _.get(additionalData, ['childData', 'childHasResponsiveLayout'], false)
		const minHeight = compProps.minHeight
		const minHeightCss = minHeight ? { 'min-height': `${minHeight}px` } : {}

		const displayValue = !minHeight ? 'block' : 'grid'
		const displayCss = { display: displayValue }

		return !hasResponsiveLayout && childHasResponsiveLayout ? { ...minHeightCss, ...displayCss } : {}
	}
)
